<template>
    <div class="w-full bg-white">
        <label-form v-if="label" :text="label"/>

        <v-select
            label="name"
            class="w-full"
            :placeholder="placeholder"
            :options="options"
            v-model="selectedOption"
            @input="$emit('input', selectedOption ? selectedOption.id: null)"
        >
            <template slot="no-options">
                <div class="py-4 mt-1">
                    {{ options.length ? 'Procurar...' : 'Nenhuma opção fornecida'}}
                </div>
            </template>
            <template slot="option" slot-scope="option">
                <div class="d-center">
                    {{ option.name }}
                </div>
            </template>
            <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">
                    {{ option.name }}
                </div>
            </template>
        </v-select>
    </div>
</template>

<script>
import LabelForm from './Label'
import eventBus from "/resources/js/Layouts/eventBus.vue";

export default {
    components: {
        LabelForm
    },
    props: {
        value: [String, Object, Boolean, Number, Array],
        placeholder: {
            type: String,
            default: 'Selecione uma Data'
        },
        label: {
            type: String,
            default: ''
        },
        options: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    data() {
        return {
            selectedOption: this.value && this.options ? this.options.find(item => this.value === item.id) : this.value
        }
    },
    created() {
        eventBus.$on("clearFilter", () => {
            this.selectedOption = null;
            this.$emit('input', null);
        });
    }
}

</script>

<style>
.v-select input {
    height: 100%;
    margin: 2px 0 !important;
    font-size: .75rem;
}

.v-select input::placeholder {
    color: rgb(107, 114, 128);
}

.v-select svg {
    scale: 0.7;
}
</style>
